import { IonButton } from "@ionic/react";
import { ReactNode } from "react";

interface NegotiationActionButtonProps {
  className: string;
  children: ReactNode;
  onClick: () => void;
}

export const NegotiationActionButton = (props: NegotiationActionButtonProps) => {
  const { onClick, className, children } = props;
  return (
    <IonButton expand="full" shape="round" fill="outline" onClick={onClick} className={className}>
      {children}
    </IonButton>
  );
};
